import { AppFullRoutes } from '../enum/appRoutes';

export const RoleAccessMap: Record<string, string[]> = {
  provider: [
    'dashboard',
    'pre-authorization',
    'eligibility-check',
    'claims',
    'billing-payment',
    'organization-billing-credits',
    'encounter',
    'referral',
    'documents-management',
    'accreditation-status',
    'report',
    'audit',
    'administration',
    'permission-management',
  ],
  insuree: [
    'dashboard',
    // 'hmo',
    'policy',
    'beneficiary',
    'premiums-payment',
    'claims',
    'encounters-referrals',
    'feedback',
    'report',
    'support-center',
  ],
  hmo: [
    'dashboard',
    'policy',
    'beneficiary',
    'provider',
    'authorization',
    'claims',
    'encounter',
    'billing-payment',
    'organization-billing-credits',
    'premiums-payment',
    'billing-credits',
    'support-center',
    'fraud-monitoring',
    'reports-analytics',
    'administration',
    'integrations',
    // 'accreditation',
    // 'employer-group',
    // 'encounter',
    // 'hmo',
    // 'master',
    // 'feedback',
    // 'report',
    // 'role-permission',
    // 'permission-management',
  ],
  nhia: [
    'dashboard',
    'policy',
    'beneficiary',
    'provider',
    'authorization',
    // 'claims',
    'claims-oversight',
    'encounter',
    'billing-payment',
    'organization-billing-credits',
    'premiums-payment',
    'billing-credits',
    'support-center',
    'fraud-monitoring',
    'reports-analytics',
    'administration',
    'integrations',
    'report',
    // 'accreditation',
    // 'employer-group',
    // 'encounter',
    // 'hmo',
    // 'master',
    // 'feedback',
    // 'report',
    // 'role-permission',
    // 'permission-management',
  ],
  superadmin: [
    'dashboard',
    'administration',
    'role-permission',
    'permission-management',
    // 'billing-payment',
    'system-configuration',
    'subscription-management',
    'reports-analytics',
    'audit-activity',
    // 'accreditation',
    'hmo',
    'master',
    'provider',
    'billing-credits',
  ],
  payer: [
    'dashboard',
    'employee-management',
    'dependant-management',
    'contributions-billing',
    'programs-providers',
    'claims',
    'organization-billing-credits',
    'documents-management',
    'report',
    'audit-activity',
  ],
};

export const RoleSubAccessMap: Record<
  string, // role
  Partial<
    Record<
      string, // parent menu key
      string[] // allowed submenu keys under that parent
    >
  >
> = {
  // examples — tweak as needed
  provider: {
    claims: [],
    referral: [],
  },
  insuree: {
    policy: [],
    beneficiary: [],
    claims: [],
    'premiums-payment': [],
  },
  hmo: {
    // master: ['manage-health-plan', 'manage-health-service', 'payment-gateway'],
    policy: ['catalog', 'program', 'pricing'],
    authorization: [
      'authorization-queues',
      'authorization-code-manager',
      'referral-management',
      'add-new-referral',
    ],
    claims: [
      'claims-management',
      'claims-review-validation',
      'claims-adjudication',
      'claims-document-review',
      'ai-claims-vetting',
      'claims-report-analytics',
    ],
    'billing-payment': [
      'capitation',
      'claims-financing-provider-payments',
      'refunds-adjustments',
    ],
    provider: ['provider-management', 'accreditation'],
  },
  nhia: {
    // master: ['manage-health-plan', 'manage-health-service', 'payment-gateway'],
    policy: ['catalog', 'program', 'pricing'],
    authorization: [
      'authorization-queues',
      'authorization-code-manager',
      'referral-management',
      'add-new-referral',
    ],
    claims: [
      'claims-management',
      'claims-review-validation',
      'claims-adjudication',
      'claims-document-review',
      'ai-claims-vetting',
      'claims-report-analytics',
    ],
    'billing-payment': [
      'capitation',
      'claims-financing-provider-payments',
      'refunds-adjustments',
    ],
    provider: ['provider-management', 'accreditation'],
    'billing-credits': [],
  },
  superadmin: {
    // super-admin sees all submenu by default; omit entry
    provider: ['provider-management', 'external-provider'],
    'billing-credits': [
      'billing-service-catalogue',
      'credit-packages',
      'organization-wallets',
      'wallet-transactions',
      'credit-purchases',
      'billing-credits-overview',
      'usage-events',
    ],
  },
  payer: {
    claims: [],
  },
};
export const MenuNameOverrideMap: Record<string, Record<string, string>> = {
  insuree: {
    claims: 'My Claims',
    report: 'My Reports',
    hmo: 'My HMOs',
    policy: 'My Policies',
    beneficiary: 'My Dependents',
    encounter: 'My Encounters',
    'subscription-management': 'My Subscriptions',
    'premiums-payment': 'My Invoices',
  },
  payer: {
    claims: 'Claims & Utilization',
  },
  hmo: {
    policy: 'Plan Portfolio',
    beneficiary: 'Membership',
    authorization: 'Authorization & Referral',
  },
  nhia: {
    policy: 'National Scheme Registry',
    authorization: 'Authorization Oversight',
    provider: 'National Provider Oversight',
    beneficiary: 'Enrollment Oversight',
    claims: 'Claims Oversight',
  },
  provider: {
    claims: 'Claims Management',
    'billing-payment': 'Payment',
  },
  //   provider: {
  //     claims: 'Provider Claims',
  //     report: 'Reports & Insights',
  //   },
  // Add more roles & overrides as needed
};

export const SubMenuNameOverrideMap: Record<
  string,
  Record<string, Record<string, string>>
> = {
  hmo: {},

  nhia: {
    policy: {
      catalog: 'National Benefit Packages',
      program: 'National Schemes',
      pricing: 'National Tariff Registry',
    },
    provider: {
      'provider-management': 'National Provider Registry',
      accreditation: 'Accreditation Oversight',
    },
    authorization: {
      'authorization-queues': 'National Authorization Queue',
      'authorization-code-manager': 'Authorization Code Registry',
      'referral-management': 'National Referral Requests',
      'add-new-referral': 'Referral Review Workbench',
    },
  },

  superadmin: {},
};

// If a parent becomes a leaf (because RoleSubAccessMap[role][parent] = []),
// you can override the link it should navigate to.
export const ParentLeafLinkMap: Record<string, Record<string, string>> = {
  hmo: {
    // Your exact ask:
    // show the "policy" parent as a leaf with this route when policy: []
    policy: AppFullRoutes.FULL_POLICY_MANAGEMENT,
  },
  nhia: {
    policy: AppFullRoutes.FULL_POLICY_MANAGEMENT,
  },
  insuree: {
    policy: AppFullRoutes.FULL_POLICY_MANAGEMENT,
    beneficiary: AppFullRoutes.FULL_DEPENDENT_ENROLLEE,
    claims: AppFullRoutes.FULL_CLAIM_MANAGEMENT,
    'premiums-payment': AppFullRoutes.FULL_BILLING_PAYMENT,
  },
  payer: {
    claims: AppFullRoutes.FULL_CLAIM_MANAGEMENT,
  },
  provider: {
    claims: AppFullRoutes.FULL_CLAIM_MANAGEMENT,
    referral: AppFullRoutes.FULL_REFERRAL_MANAGEMENT,
  },

  // super-admin: { ... },
  // provider: { ... },
};
